import React, { useState, useEffect } from "react";
import MuiModal from "./MuiModal";
import CloseIcon from "@mui/icons-material/Close";
import MuiButton from "./MuiButton";

// import JS files

// import Others files

const TableIconModalWithTwoHandle = ({
  children,
  isRemove,
  removeText,
  icon,
  width,
  isOverflow,
  isNotBackdropClick,
  openModal,
  setOpenModal,
  handleRemoveOnClick,
  handleNoOnClick,
  apiCall,
  RefetchNeed,
  NeedCloseState,
  NeedClose,
  
}) => {
  const handleModal = () => {
    setOpenModal((before) => !before);
    
  };
  return (
    <>
      {openModal && (
        <MuiModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          width={width}
          isOverflow={isOverflow}
          isNotBackdropClick={isNotBackdropClick}
        >
          {isRemove ? (
            <>
              <div>
                <div>
                  <span className="text-sm">{removeText}</span>
                </div>
                <div className="flex justify-end mt-4">
                  <div className="mr-2">
                    <MuiButton
                      onClick={handleRemoveOnClick}
                      variant="outlined"
                      //     icon={<AddIcon />}
                      color="error"
                      text="بلی"
                    />
                  </div>
                  <div className="mr-2">
                    <MuiButton
                      onClick={handleNoOnClick}
                      variant="outlined"
                      //     icon={<AddIcon />}
                      color="success"
                      text="خیر"
                    />
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {isOverflow && (
                <div className="close-modal-icon">
                  <CloseIcon
                    onClick={() => {
                      if (RefetchNeed) apiCall.reFetch();
                      if (NeedClose) NeedCloseState(false);
                      setOpenModal(false);
                    }}
                    fontSize="large"
                    color="secondary"
                  />
                </div>
              )}

              {children}
            </>
          )}
        </MuiModal>
      )}
      <div className="table-icon" onClick={() => handleModal()}>
        {icon}
      </div>
    </>
  );
};

export default TableIconModalWithTwoHandle;
